import { render, staticRenderFns } from "./QrCodeSettings.vue?vue&type=template&id=4047d659&scoped=true"
import script from "./QrCodeSettings.vue?vue&type=script&lang=ts"
export * from "./QrCodeSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047d659",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4047d659')) {
      api.createRecord('4047d659', component.options)
    } else {
      api.reload('4047d659', component.options)
    }
    module.hot.accept("./QrCodeSettings.vue?vue&type=template&id=4047d659&scoped=true", function () {
      api.rerender('4047d659', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/QrCodeSettings.vue"
export default component.exports